import Wrapper from '../../../core/wrapper';

export default {
  components: {
    Wrapper,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    legend: {
      type: String,
      required: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
    },
    image: {
      type: String,
      required: false,
    },
  },
  computed: {
    showPanel() {
      return this.show;
    },
  },

  methods: {
    hide() {
      if (typeof this.onClose !== 'undefined') {
        this.onClose();
      }
    },
  },
  mounted() {
    this.escapeEvent = window.addEventListener('keyup', (evt) => {
      if (evt.keyCode === 27 && this.show) {
        this.hide();
      }
    });
  },
  destroyed() {
    window.removeEventListener('keyup', this.escapeEvent);
  },
};
